import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { RangeInputConditionalValue } from '../../model/model';
import { ConditionalTemplateRunner } from '../../service/data';

@Component({
	selector: 'common-ct-runner-range-input',
	templateUrl: './ct-runner-range-input.component.html',
	styleUrls: ['./ct-runner-range-input.component.scss']
})
export class CtRunnerRangeInputComponent implements OnInit {
	@HostBinding('class.ct-runner-range-input') hostClass = true;
	@Input() data: ConditionalTemplateRunner;
	getLowValue() {
		const d = this.data.Data.Value as RangeInputConditionalValue;
		if (d && d.LowValue) {
			return d.LowValue;
		}
		return '';
	}
	getHighValue() {
		const d = this.data.Data.Value as RangeInputConditionalValue;
		if (d && d.HighValue) {
			return d.HighValue;
		}
		return '';
	}
	setLowValue(val: string) {
		let d = this.data.Data.Value as RangeInputConditionalValue;
		if (!d) {
			d = {} as RangeInputConditionalValue;
			this.data.Data.Value = d;
		}
		d.LowValue = val;
		this.data.enable = !!d.LowValue || !!d.HighValue;
	}
	setHighValue(val: string) {
		let d = this.data.Data.Value as RangeInputConditionalValue;
		if (!d) {
			d = {} as RangeInputConditionalValue;
			this.data.Data.Value = d;
		}
		d.HighValue = val;
		this.data.enable = !!d.LowValue || !!d.HighValue;
	}
	constructor() {}

	ngOnInit() {}
}
